(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blogs-feed"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.video-feeds').forEach(wrapper => {
    const video = wrapper.querySelector('.video-media video');
    const button = wrapper.querySelector('.play-button');

    video.pause(); // Ensure it's paused initially

    // Show play button when paused manually (e.g., user clicks video)
    video.addEventListener('pause', () => {
      button.style.display = 'flex';
    });

    // Hide play button when playing
    video.addEventListener('play', () => {
      button.style.display = 'none';
    });

    // Show play button again when video ends
    video.addEventListener('ended', () => {
      button.style.display = 'flex';
      video.currentTime = 0; // Optional: rewind to start
    });

    // Play on button click
    button.addEventListener('click', () => {
      video.play();
    });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-feeds"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.video-feeds').forEach(wrapper => {
    const video = wrapper.querySelector('.video-media video');
    const button = wrapper.querySelector('.play-button');

    video.pause(); // Ensure it's paused initially

    // Show play button when paused manually (e.g., user clicks video)
    video.addEventListener('pause', () => {
      button.style.display = 'flex';
    });

    // Hide play button when playing
    video.addEventListener('play', () => {
      button.style.display = 'none';
    });

    // Show play button again when video ends
    video.addEventListener('ended', () => {
      button.style.display = 'flex';
      video.currentTime = 0; // Optional: rewind to start
    });

    // Play on button click
    button.addEventListener('click', () => {
      video.play();
    });
});

document.querySelectorAll('video').forEach(video => {
  video.removeAttribute('autoplay');
  video.pause();
});


  } catch(e) { console.error(e); }
})();
})();
